
import api from '../api';

/**
 * Fetch a user by phone number.
 *
 * @param {string} phone - The phone number of the user.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails or phone number is not provided.
 */
const getUser = async (phone) => {
  if (!phone) {
    throw new Error('Phone number is required.');
  }

  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/get?phone=${encodeURIComponent(phone)}`;

  try {
    const response = await api.get(endpoint);

    return response.data;
  } catch (error) {
    console.error(`Error while fetching user with phone ${phone}:`, error);
    throw error;
  }
}

export default getUser;
